import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

/**
 * Bordered-card section wrapper for the Product form. Mirrors the
 * theme-new visual idiom used by SettingsSection / ReportSection
 * (icon bubble + h6 title + optional description, divider, body).
 * Local to the warehouse surface so it can drift independently.
 */
export default function ProductFormSection({ icon, title, description, action, children, sx }) {
  return (
    <Card
      variant="outlined"
      sx={{
        px: { xs: 2, md: 3 },
        py: 2.5,
        ...sx,
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0 }}>
          {icon ? (
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'action.hover',
                color: 'primary.main',
                flexShrink: 0,
                '& svg': { fontSize: 22 },
              }}
            >
              {icon}
            </Box>
          ) : null}
          <Stack spacing={0.25} sx={{ minWidth: 0 }}>
            <Typography variant="h6" component="h2" sx={{ lineHeight: 1.3 }}>
              {title}
            </Typography>
            {description ? (
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            ) : null}
          </Stack>
        </Stack>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Stack>
      <Divider sx={{ my: 2.5 }} />
      <Box>{children}</Box>
    </Card>
  );
}
